import { useMemo } from 'react';
import { lessonsEditorApi } from 'Lessons';
import { titleWithTag } from 'ContentItemEditor';
import { type EditorCourseOption } from './PlaylistEditor.types';

/*
    English courses only, whatever the playlist's own locale. The shared query covers every locale,
    so the narrowing happens here. A course with no locale pack cannot go on a playlist.
*/
export function useEditorCourses() {
    const { data, isLoading } = lessonsEditorApi.useGetCoursesForEditorListQuery();

    const courses = useMemo<EditorCourseOption[]>(
        () =>
            (data?.contents?.lessonStreams || []).flatMap(course => {
                const localePackId = course.localePack?.id;
                if (!localePackId || (course.locale || 'en') !== 'en') return [];

                return [{ id: course.id, title: course.title, tag: course.tag, localePackId }];
            }),
        [data],
    );

    const coursesByLocalePackId = useMemo(
        () => Object.fromEntries(courses.map(course => [course.localePackId, course])),
        [courses],
    );

    return { courses, coursesByLocalePackId, isLoading };
}

export function courseTitle(course: EditorCourseOption | undefined) {
    // A course can be deleted while a playlist still holds it.
    if (!course) return '☢☢☢ COURSE NOT FOUND ☢☢☢ Probably deleted?';
    return titleWithTag(course);
}
